import { useState } from "react"

import { useCloseableSnackbarState } from "../../../common/components/CloseableSnackbar"
import BulkSendEmailCampaignDialog from "./BulkSendEmailCampaignDialog"
import ConfirmConnectEmailDialog, {
  useConnectEmailDialogRequirements,
} from "./ConfirmConnectEmailDialog"

export default function BulkSendEmailCampaignDialogCombo({
  bulkSendEmailCampaignDialogOpen,
  handleBulkSendEmailCampaignDialogClosed,
  onSendEmailCampaignButtonClicked,
  confirmConnectGmailDialogOpen,
  handleConfirmConnectGmailDialogClosed,
  candidateCount,
  isSending,
}) {
  return (
    <>
      <BulkSendEmailCampaignDialog
        open={bulkSendEmailCampaignDialogOpen}
        onClose={handleBulkSendEmailCampaignDialogClosed}
        onSendButtonClicked={onSendEmailCampaignButtonClicked}
        candidateCount={candidateCount}
        isSending={isSending}
      />
      <ConfirmConnectEmailDialog
        open={confirmConnectGmailDialogOpen}
        onClose={handleConfirmConnectGmailDialogClosed}
      />
    </>
  )
}

export function useBulkSendEmailCampaignDialogComboState(
  onEmailCampaignSent = () => {}
) {
  const [bulkSendEmailCampaignDialogOpen, setBulkSendEmailCampaignDialogOpen] =
    useState(false)
  const {
    emailAuthorized,
    confirmConnectEmailDialogOpen,
    openConfirmConnectEmailDialog,
    handleConfirmConnectGmailDialogClosed,
  } = useConnectEmailDialogRequirements()
  const {
    open: openSnackbar,
    message: snackbarMessage,
    isOpen: isSnackbarOpen,
    close: closeSnackbar,
    severity: snackbarSeverity,
  } = useCloseableSnackbarState()
  const [isSendingBulkCampaign, setIsSendingBulkCampaign] = useState(false)

  function handleBulkSendEmailCampaignDialogClosed(sent) {
    if (sent) {
      openSnackbar("Email template sent out successfully")
      onEmailCampaignSent()
    }
    setBulkSendEmailCampaignDialogOpen(false)
  }

  function handleSendEmailButtonClicked() {
    if (emailAuthorized) {
      setBulkSendEmailCampaignDialogOpen(true)
    } else {
      openConfirmConnectEmailDialog()
    }
  }

  return {
    bulkSendEmailCampaignDialogOpen,
    confirmConnectEmailDialogOpen,
    openConfirmConnectEmailDialog,
    emailAuthorized,
    openSnackbar,
    snackbarMessage,
    isSnackbarOpen,
    closeSnackbar,
    snackbarSeverity,
    isSendingBulkCampaign,
    setIsSendingBulkCampaign,
    handleSendEmailButtonClicked,
    handleBulkSendEmailCampaignDialogClosed,
    handleConfirmConnectGmailDialogClosed,
  }
}
